module.exports = __webpack_public_path__ + "static/business_transformation_graphic-9ab54e74fd0ce5c54f5945bd119f67e3.png";